import { Component, effect, inject, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { MediaFacade } from '@app/store/media';
import {
    MediaImageComponent,
    MediaVideoComponent,
    MediaAudioComponent,
    MediaPdfComponent,
    MediaTextComponent,
    TypeChipComponent,
    UnavailableComponent,
} from '@shared/components';
import { DeleteButtonComponent } from './delete-button/delete-button.component';

@Component({
    selector: 'app-media-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [
        DatePipe,
        TranslateModule,
        ButtonModule,
        MediaImageComponent,
        MediaVideoComponent,
        MediaAudioComponent,
        MediaPdfComponent,
        MediaTextComponent,
        TypeChipComponent,
        UnavailableComponent,
        DeleteButtonComponent,
    ],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly mediaFacade = inject(MediaFacade);

    private readonly mediaId = this.route.parent?.snapshot.params['id'] ?? '';

    readonly media = this.mediaFacade.selectMedia(this.mediaId);
    readonly loading = this.mediaFacade.selectLoading(this.mediaId);
    readonly error = this.mediaFacade.selectError(this.mediaId);
    readonly saving = this.mediaFacade.saving;

    constructor() {
        if (this.mediaId) {
            this.mediaFacade.getMedia(this.mediaId);
        }

        effect(() => {
            if (this.mediaFacade.saved()) {
                this.close({ replaceUrl: !this.media() });
            }
        });
    }

    ngOnDestroy(): void {
        this.mediaFacade.clear();
    }

    onEdit(): void {
        const media = this.media();
        if (media) {
            this.router.navigate([{ outlets: { modal: ['media', 'edit', media.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
